/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react'
import type { SVGProps } from 'react'
/**
 * @internal
 */
const SvgHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={24}
    fill="none"
    viewBox="0 0 512 512"
    {...props}
  >
    <path
      fill="#F91F31"
      d="m47.6 258.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l180.7-168.7c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347-5.5 300.6 9.4 268 42l-12 12-12-12C211.4 9.4 165-5.5 119.4 2.1 50.5 13.6 0 73.2 0 143.1v5.8c0 41.5 17.2 81.2 47.6 109.5"
    />
  </svg>
)
export default SvgHeart
